import {
	type RemoveTenantSmtpConnectionMutation,
	type SetTenantSmtpConnectionMutation,
	type VerifyTenantSmtpConnectionMutation
} from "~/gql/mutations/tenantSmtpConnection.generated";
import { type GetTenantSmtpConnectionQuery } from "~/gql/queries/tenantSmtpConnection.generated";

export const emailSmtpEndpoints = {
	GetTenantSmtpConnection: {
		providesTags: ["TenantSmtpConnection"] as AddTagTypes,
		transformResponse: (res: GetTenantSmtpConnectionQuery) => res
	},
	RemoveTenantSmtpConnection: {
		invalidatesTags: ["TenantSmtpConnection", "TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: RemoveTenantSmtpConnectionMutation) => res
	},
	SetTenantSmtpConnection: {
		invalidatesTags: ["TenantSmtpConnection", "TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: SetTenantSmtpConnectionMutation) => res
	},
	VerifyTenantSmtpConnection: {
		invalidatesTags: ["TenantSmtpConnection", "TenantEmailSenders"] as AddTagTypes,
		transformResponse: (res: VerifyTenantSmtpConnectionMutation) => res
	}
};
